import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

export function loadGLB(objectFile, inThreeViewer) {
    
    return new Promise((res, rej) => {
        
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

        const loader = new GLTFLoader();
        loader.setDRACOLoader(dracoLoader);
        loader.load(objectFile,
            function (gltf) {
                gltf.scene.traverse(function (child) {
                    if (child.isMesh) {
                        child.material.transparent = true
                    }
                });
                gltf.scene.name = "avatar"
                res(gltf.scene);
            },

            function (xhr) { },
            function (error) {
                res(error)
            }
        );
    })
}
